import styled from 'styled-components';

export const NameCell = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  color: ${({ theme }) => theme.palette.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DescriptionCell = styled.span`
  font-size: 14px;
  line-height: 1.3;
  color: ${({ theme }) => theme.palette.text.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
